<template>
  <b-dropdown
    class="dropdown-page"
    block
    toggle-class="text-decoration-none text-left"
    variant="light select-page"
    v-b-tooltip.hover
    ref="dropdown"
    :title="$t('engine.topbar.page.lblTitle', languageEngine)"
    id="btn-select-page-header"
    style="position: relative"
  >
    <template #button-content>
      <div 
        @click="text = ''" 
      >
        <span class="btn-select-page-selected">
          <span class="color" style="color: #53585D">
            {{ $t("engine.topbar.lblPage", languageEngine) }}:
          </span>
          <span class="text-blue">{{ selectedPageName }}</span>
        </span>
        <span class="btn-select-page-arrow"><i class="far fa-angle-down"></i></span>
      </div>
    </template>

    <perfect-scrollbar
      @ps-y-reach-end="scrollEnd"
      @ps-y-reach-start="scrollStrat"
      @ps-scroll-up="scrollUp"
      @ps-scroll-down="scrollDown"
      ref="scrollbar"
    >
      <div id="search">
        <div style="position: relative; padding: 7px 15px 15px 15px">
          <b-form-input
            v-model="text"
            :placeholder="$t('engine.topbar.page.plcTitle', languageEngine)"
          ></b-form-input>
          <span
            class="text-muted"
            style="position: absolute; right: 28px; top: 12px"
          >
            <i class="far fa-search"></i>
          </span>
        </div>
        <div v-if="!text && scrollingT" id="sh-top" class="sh-top-menu" />
      </div>
      <div v-if="text !== ''" class="fs-sa-14 px-15 mb-10">
        {{ $t("engine.topbar.page.lblSearchResult", languageEngine) }} 
        ({{ countSearch }})
        <hr class="my-0" />
      </div>
      <div class="text-center text-muted fs-sa-14" v-if="countSearch === 0">
        {{ $t("engine.topbar.page.lblSearchNotFound", languageEngine) }}
      </div>
      <div v-for="key in Object.keys(getListByType)" :key="`${key}`">
        <b-dropdown-group
          v-if="getListByType[key][0].data > 0"
          :id="`dropdown-group-${key}`"
          :header="
            key == 'custom'
              ? $t('engine.topbar.page.lblTitleCustomPage', languageEngine)
              : $t('engine.topbar.page.lblTitleSystemPage', languageEngine)
          "
        >
          <span
            v-for="page in getListByType[key]"
            :key="`custom_${page.id}_headermenu`"
            @click="setPage(page.properties.metaDataID)"
          >
            <b-dropdown-item-button
              v-if="page.show"
              class="text-truncate"
              :class="{
                lastItem:
                  page.id === isLast(key, 'listType') &&
                  getListByType[key].length > 1,
              }"
              :active="sitePageID === page.id"
            >
              {{ page.properties.name || capitalize(page.properties.type) }}
            </b-dropdown-item-button>
          </span>
        </b-dropdown-group>
      </div>
      <b-dropdown-group
        v-if="example[0].data > 0"
        :header="$t('engine.topbar.page.lblTitleExamplePage', languageEngine)"
      >
        <span
          v-for="(exam, index) in example"
          :key="`content_${index}`"
          @click="setPageStatic(exam.value)"
        >
          <b-dropdown-item-button
            v-if="exam.show"
            class="text-truncate"
            :class="{
              lastItem: exam.text === isLast(index, 'exam', exam),
            }"
            :active="sitePageID === exam.value"
          >
            {{ exam.text }}
          </b-dropdown-item-button>
        </span>
      </b-dropdown-group>

      <div class="p-15 btn-manage-page" id="manage-btn">
        <div v-if="!text && scrollingB" id="sh-bottom" class="sh-bottom-menu" />
        <b-button class="fs-sa-14" variant="blue" @click="managePage" block>
          {{ $t("engine.topbar.page.btnManagePage", languageEngine) }}
        </b-button>
      </div>
    </perfect-scrollbar>
  </b-dropdown>
</template>

<script>
import { capitalize } from "@helpers/text.helper";
import { PerfectScrollbar } from "vue2-perfect-scrollbar";
import { mapGetters } from "vuex";

export default {
  components: {
    PerfectScrollbar,
  },
  data() {
    return {
      text: "",
      scrollingT: false,
      scrollingB: false,
    };
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
      siteComponents: "design/metadata/siteComponents",
      pageName: "design/page/pageName",
      sitePageID: "design/metadata/sitePageID",
      product: "design/page/product",
      blog: "design/page/blog",
      post: "design/page/post",
      album: "design/page/album",
      albumCategory: "design/page/albumCategory",
      eventCalendar: "design/page/eventCalendar",
      permissions: "design/permissionWebsite/permissions",
    }),
    selectedPageName(){
      let text = ''
      switch(this.pageName){
        case 'Blog':
          text = this.$t('engine.topbar.page.lblBlog', this.languageEngine)
          break
        case 'Post':
          text = this.$t('engine.topbar.page.lblPost', this.languageEngine)
          break
        case 'Photo':
          text = this.$t('engine.topbar.page.lblAlbum', this.languageEngine)
          break
        case 'Photo Album':
          text = this.$t('engine.topbar.page.lblAllAlbum', this.languageEngine)
          break
        case 'All Product':
          text = this.$t('engine.topbar.page.lblProductAll', this.languageEngine)
          break
        case 'Product Detail':
          text = this.$t('engine.topbar.page.lblProductDetail', this.languageEngine)
          break
        case 'Event Calendar Detail':
          text = this.$t('engine.topbar.page.lblEventCalendarDetail', this.languageEngine)
          break
        default:
          text = this.pageName
      }
      return text;
    }, 
    blogDefault() {
      return [
        {
          value: "blog",
          text: this.$t("engine.topbar.page.lblBlog", this.languageEngine),
          show: false,
        },
      ];
    },
    postDefault() {
      return   [{
          value: "post",
          text: this.$t("engine.topbar.page.lblPost", this.languageEngine),
          show: false,
        }]
    },
    AlbumDefault() {
      return [
        {
          value: "album_item",
          text: this.$t("engine.topbar.page.lblAlbum", this.languageEngine),
          show: false,
        },
      ];
    },
    AlbumCategoryDefault() {
      return [
        {
          value: "album_list",
          text: this.$t("engine.topbar.page.lblAllAlbum", this.languageEngine),
          show: false,
        },
      ];
    },
    eventCalendarDefault() {
      return [
        {
          value: "event_calendar_item",
          text: this.$t('engine.topbar.page.lblEventCalendarDetail', this.languageEngine),
          show: false,
        },
      ];
    },
    productDefault() {
      return [
        { data: 0 },
        {
          value: "product_list",
          text: this.$t(
            "engine.topbar.page.lblProductAll",
            this.languageEngine
          ),
          show: false,
        },
        {
          value: "product_item",
          text: this.$t(
            "engine.topbar.page.lblProductDetail",
            this.languageEngine
          ),
          show: false,
        },
        {
          value: "cart",
          text: this.$t("engine.topbar.page.lblCart", this.languageEngine),
          show: false,
        },
        {
          value: "shipping",
          text: this.$t(
            "engine.topbar.page.lblCartShipping",
            this.languageEngine
          ),
          show: false,
        },
        {
          value: "payment",
          text: this.$t(
            "engine.topbar.page.lblCartPayment",
            this.languageEngine
          ),
          show: false,
        },
        {
          value: "success",
          text: this.$t(
            "engine.topbar.page.lblCartSuccess",
            this.languageEngine
          ),
          show: false,
        },
      ];
    },
    productCount() {
      return this.product && this.product.count;
    },
    blogCount() {
      return this.blog && this.blog.count;
    },
    albumCount() {
      return this.album && this.album.count;
    },
    postCount() {
      return this.post && this.post.count;
    },
    albumCategoryCount() {
      return this.albumCategory && this.albumCategory.count;
    },
    eventCalendarCount() {
      return this.eventCalendar && this.eventCalendar.countAll;
    },
    getListByType() {
      var object_list = {
        custom: [{ data: 0 }],
        system: [{ data: 0 }],
      };

      if (this.siteComponents) {
        Object.entries(JSON.parse(JSON.stringify(this.siteComponents))).forEach(([key, item]) => {
          key;
          let type = "plus";
          if (item.type === "PAGE") {
            if (
              item.properties.name &&
              item.properties.name
                .toLowerCase()
                .indexOf(this.text.toLowerCase()) > -1
            ) {
              item.show = true;
            } else if (
              item.properties.type &&
              item.properties.type
                .toLowerCase()
                .indexOf(this.text.toLowerCase()) > -1
            ) {
              item.show = true;
            } else {
              item.show = undefined;
              type = "minus";
            }
            switch (item.properties.groupType) {
              case "system":
                type === "plus" ? (object_list.system[0].data += 1) : "";
                object_list.system.push(item);
                break;
              case "custom":
                type === "plus" ? (object_list.custom[0].data += 1) : "";
                object_list.custom.push(item);
                break;
              default:
            }
          }
        });
      }
      return object_list;
    },

    example() {
      var object_list = [{ data: 0 }];

      if(this.postCount > 0 && this.permissions.isContent == '1') {
        this.blogDefault.map((item) => {
          if (
            item.text &&
            item.text.toLowerCase().indexOf(this.text.toLowerCase()) > -1
          ) {
            object_list.push({ ...item, show: true });
            object_list[0].data++;
          }
        });
      }

      if(this.postCount > 0 && this.permissions.isContent == '1') {
        this.postDefault.map((item) => {
          if (
            item.text &&
            item.text.toLowerCase().indexOf(this.text.toLowerCase()) > -1
          ) {
            object_list.push({ ...item, show: true });
            object_list[0].data++;
          }
        });
      }


      if(this.albumCategoryCount > 0) {
        this.AlbumCategoryDefault.map((item) => {
          if (
            item.text &&
            item.text.toLowerCase().indexOf(this.text.toLowerCase()) > -1
          ) {
            object_list.push({ ...item, show: true });
            object_list[0].data++;
          }
        });
      }
      
      if(this.albumCount > 0) {
        this.AlbumDefault.map((item) => {
          if (
            item.text &&
            item.text.toLowerCase().indexOf(this.text.toLowerCase()) > -1
          ) {
            object_list.push({ ...item, show: true });
            object_list[0].data++;
          }
        });
      }
      
      if(this.productCount > 0 && this.permissions.isProduct == '1') {
        let arrayProductTypeShow = ['product_list', 'product_item']
        this.productDefault.map((product) => {
          if (
            arrayProductTypeShow.includes(product.value) &&
            product.text.toLowerCase().indexOf(this.text.toLowerCase()) > -1
          ) {
            object_list.push({ ...product, show: true });
            object_list[0].data++;
          }
        });
      }

      if(this.eventCalendarCount > 0 && this.permissions.IsCalendar == '1') {
        this.eventCalendarDefault.map((item) => {
          if (
            item.text &&
            item.text.toLowerCase().indexOf(this.text.toLowerCase()) > -1
          ) {
            object_list.push({ ...item, show: true });
            object_list[0].data++;
          }
        });
      }
      return object_list;
    },
    countSearch() {
      return (
        this.getListByType.custom[0].data +
        this.getListByType.system[0].data +
        this.example[0].data
      );
    },
  },

  methods: {
    capitalize,
    scrollEnd() {
      if (
        document.getElementById("sh-bottom") &&
        document.getElementById("sh-top")
      ) {
        document.getElementById("sh-bottom").classList.add("remove-shadow");
        document.getElementById("sh-top").classList.remove("remove-shadow");
      }
    },
    scrollStrat() {
      if (
        document.getElementById("sh-bottom") &&
        document.getElementById("sh-top")
      ) {
        document.getElementById("sh-bottom").classList.remove("remove-shadow");
        document.getElementById("sh-top").classList.add("remove-shadow");
      }
    },
    scrollUp() {
      this.scrollingB = true;
      this.scrollingT = true;
      if (document.getElementById("sh-bottom")) {
        document.getElementById("sh-bottom").classList.remove("remove-shadow");
      }
    },
    scrollDown() {
      this.scrollingB = true;
      this.scrollingT = true;
      if (document.getElementById("sh-top")) {
        document.getElementById("sh-top").classList.remove("remove-shadow");
      }
    },

    managePage() {
      this.$bvModal.show("modal-manage-page");
      this.$refs.dropdown.hide(true);
    },
    async setPage(id) {
      await this.$store.dispatch('design/snapshot/synceSnapshot', {});
      this.$store.dispatch('design/blockloading', {});
      this.$store.dispatch("designIframe/page/getPage", { metaDataID: id }).then(() => {
        setTimeout(() => this.$store.dispatch("design/unblockloading", {}), 2000)
      })
      this.$store.dispatch("design/component/elActive", {});

    },
    async setPageStatic(id) {
      await this.$store.dispatch('design/snapshot/synceSnapshot', {})
      this.$store.dispatch('design/blockloading', {});
      this.$store.dispatch("designIframe/page/getPageStatic", {
        metaDataID: id,
      }).then(() => {
        setTimeout(() => this.$store.dispatch("design/unblockloading", {}), 2000)
      });
      this.$store.dispatch("design/component/elActive", {});
    },
    isLast(key, type) {
      let lastIndex = "";
      if (type === "listType") {
        let lastName = this.getListByType[key].slice(-1);
        lastIndex = lastName[0].id;
      } else if (type === "exam") {
        let lastName = this.example.slice(-1);
        lastIndex = lastName[0].text;
      }
      return lastIndex;
    },
  },
  watch: {
    elActiveID: function () {
      this.$refs.dropdown.hide(true);
    },
  },
};
</script>

<style lang="scss">
#search {
  position: sticky;
  background-color: white;
  height: 60px;
  /* top: -8px; */
  padding-top: 1px;
  box-shadow: unset;
}
#manage-btn.btn-manage-page {
  position: sticky;
  padding: 15px;
  background-color: white;

  bottom: -9px;
}

.sh-bottom-menu {
  position: absolute;
  bottom: 65px;
  left: 0px;
  width: 96.7%;
  height: 100px;
  z-index: 99;
  pointer-events: none;
  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0.5) 50%,
    rgba(255, 255, 255, 0.3) 70%,
    rgba(255, 255, 255, 0) 100%
  );
}
.sh-bottom-menu.remove-shadow {
  background: transparent;
}
.sh-top-menu {
  position: absolute;
  top: 59px;
  width: 96.7%;
  height: 100px;
  z-index: 99;
  pointer-events: none;
  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.3) 50%,
    rgba(255, 255, 255, 0.5) 70%,
    rgba(255, 255, 255, 1) 100%
  );
}
.sh-top-menu.remove-shadow {
  background: transparent;
}

// Dropdown
#btn-select-page-header {
  width: 240px;
  font-family: "Sarabun";
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
}

// Toggle
#btn-select-page-header .dropdown-toggle::after { display: none !important; }
#btn-select-page-header .dropdown-toggle::before { display: none !important; }
#btn-select-page-header .dropdown-toggle.btn { 
  max-width: 100%;
  height: 34px;
  padding: 6px 34px 6px 12px; 
  font-family: "Sarabun";
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  color: #373E44; 
  background-color: #F8F9FA; 
  border: 1px solid transparent;
  outline: 0;
  box-shadow: unset;
  -webkit-box-shadow: unset;
  transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
  -webkit-transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
  -o-transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}
#btn-select-page-header .dropdown-toggle.btn:hover { border-color: #DEE3E6; }
#btn-select-page-header .dropdown-toggle.btn:focus,
#btn-select-page-header.show .dropdown-toggle.btn {
  border-color: #24BEE2;
  outline: 0;
  box-shadow: 0px 0px 6px 2px rgb(36 190 226 / 25%), inset 0px 1px 2px rgb(0 0 0 / 10%);
  -webkit-box-shadow: 0px 0px 6px 2px rgb(36 190 226 / 25%), inset 0px 1px 2px rgb(0 0 0 / 10%);
}
#btn-select-page-header[readonly] .dropdown-toggle.btn {
  background-color: #E9ECEF;
}
#btn-select-page-header .dropdown-toggle.btn.disabled,
#btn-select-page-header .dropdown-toggle.btn:disabled {
  opacity: 1;
  cursor: none;
  pointer-events: none;
  color: #6C757D;
  background-color: #E9ECEF;
}

/* Selected */
#btn-select-page-header .btn-select-page-selected {
  display: inline-block;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* Arrow */
#btn-select-page-header .btn-select-page-arrow {
  position: absolute;
  right: 12px;
  width: 10px;
  max-width: 10px;
  font-size: 16px;
}

// PerfectScroll
#btn-select-page-header .ps {
  max-height: calc(100vh - 80px);
  height: auto;
}
#btn-select-page-header .ps .ps__rail-x:hover,
#btn-select-page-header .ps .ps__rail-y:hover,
#btn-select-page-header .ps .ps__rail-x:focus,
#btn-select-page-header .ps .ps__rail-y:focus,
#btn-select-page-header .ps .ps__rail-x.ps--clicking,
#btn-select-page-header .ps .ps__rail-y.ps--clicking {
  opacity: 0.6;
}
#btn-select-page-header .ps__rail-y:hover > .ps__thumb-y,
#btn-select-page-header .ps__rail-y:focus > .ps__thumb-y,
#btn-select-page-header .ps__rail-y.ps--clicking .ps__thumb-y {
  width: 6px;
}
#btn-select-page-header .ps__rail-y {
  width: 0px;
}

// Header
#btn-select-page-header .dropdown-header {
  padding: 6px 20px;
  margin-bottom: 0;
  font-family: "Sarabun";
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  color: #84929F; 
  background-color: #F8F9FA;
  white-space: nowrap;
}

// Menu
#btn-select-page-header .dropdown-menu {
  max-width: 240px;
  min-width: 240px;
  height: auto;
  max-height: calc(100vh - 60px);
  overflow-y: auto;
  overflow-x: hidden;
  background-color: white;
  border: 0px white;
  box-shadow: 0px 16px 48px 0px rgba(0, 0, 0, 0.176);
}
#btn-select-page-header .dropdown-item { 
  padding: 5px 20px;
  font-family: "Sarabun";
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  color: #373E44; 
  background-color: transparent;
}
#btn-select-page-header .dropdown-item.active, 
#btn-select-page-header .dropdown-item:active { color: #24BEE2; }
#btn-select-page-header .dropdown-item:hover { background-color: #F4FCFF; }
#btn-select-page-header .dropdown-item.disabled, 
#btn-select-page-header .dropdown-item:disabled {
  pointer-events: auto;
  cursor: default;
  color: #A5A5A5;
}
#btn-select-page-header .lastItem {
  padding: 0px 0px 10px 0px;
}

li button {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>